<template>
  <!--  SPINERS CARGA TABLA -->
  <div v-if="loadingComponent" class="spinner-container container-fluid">
    <Loading-Style/>
  </div>
    
  <div v-if="!loadingComponent && responseDATA">

      <div class="container container-fluid py-4">
        <div class="row">
          <div class="col-md-4">
            <label for="formName" class="form-label text-left">Nombre</label>
            <input type="text" class="form-control"  id="formName" v-model="formName"/>
          </div>
        </div>
      </div>

      <div class="table-container-scrollable-create">
        <table
          class="table table-striped table-hover table-bordered text-center table-rounded mt-2"
        >
        <thead class="table-secondary">
            <tr>
              <th>ID</th>
              <th>Descripcion</th>
              <th>
                <div class="row">
                  <div class="col-md-6" >
                    Seleccione todos
                  </div>
                  <div class="col form-check form-switch">
                    <input 
                    type="checkbox"
                    class="form-check-input" 
                    v-model="selectAll" 
                    @change="toggleSelectAll" />
                </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in responseDATA" :key="index">
              <td>{{ row.id }}</td>
              <td>{{ row.description }}</td>
              <td>
                <ul class="">
                  <li>
                    <div class="form-check form-switch">
                      <input
                        type="checkbox"
                        :id="'checkbox_' + index"
                        class="form-check-input"
                        v-model="row.selected"
                      />
                      <label :for="'checkbox_' + index" class="form-check-label"></label>
                    </div>
                  </li>
                </ul> 
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-for="(customField, index) in customFields" :key="index">
        <div class="form-group mt-2">
          <label class="form-label" :for="'custom_field_' + index">Campo personalizado {{ index + 1 }}</label>
          <input
            :id="'custom_field_' + index"
            type="text"
            placeholder="Nombre del nuevo campo"
            class="form-control"
            :name="'custom_field_' + index"
            v-model="customField.value"
          />
        </div>
      </div>
      <div @click="addCustomField" class="btn btn-secondary mt-2">Agregar Campo Personalizado</div>

  </div>

</template>

<script>
  import { ref, onMounted, watch } from 'vue'
  import apiAdmin from '../../../apis/Admin'
  import { handleError } from '../../../Utils/StatusHandler'


  export default {
    name: 'FormCreateCompanyPrimary',
    emits: ['formData1'],
    setup(_, { emit }) {
      const loadingComponent = ref(false);
      const response = ref(null);
      const responseDATA = ref(null);

      const errors = ref([]);

      const formName = ref('');
      const customFields = ref([]);
      const selectedFields = ref({});
      const selectAll = ref(false);

      const handleErrors = (error) => {
        handleError(error, { errors });
      };

      const setDataValues = async () => {
        try {
          loadingComponent.value = true;
          const response = await apiAdmin.getFormsField();

          if (response) {
            const resultadosDATA = response.data;
            responseDATA.value = resultadosDATA.map(form => ({ ...form, selected: false }));
          }

        } catch (error) {
          console.error(error);
          handleErrors(error);
        } finally {
          loadingComponent.value = false;
        }
      };


      const addCustomField = () => {
        customFields.value.push({ value: '' });
      };

      watch(
        () => responseDATA.value?.map(row => row.selected),
        () => {
          if (responseDATA.value) {
            selectedFields.value = responseDATA.value.reduce((acc, row, index) => {
              acc[index] = row.selected;
              return acc;
            }, {});
          }
        }
      );

      const emitFormData = () => {
        emit('formData1', {
          component: 'FormCreateCompanyPrimary',
          formData: {
            formName: formName.value,
            customFields: customFields.value,
            selectedFields: selectedFields.value,
          },
        });
      };
      
      const toggleSelectAll = () => {
        responseDATA.value.forEach(row => {
          row.selected = selectAll.value;
        });
      };

      watch(
        [formName, customFields, selectedFields],
        () => {
          emitFormData();
        },
        { deep: true }
      );

      onMounted(() => {
        setDataValues();
      });

      return {
        errors,
        loadingComponent,
        response,
        responseDATA,
        formName,
        customFields,
        selectAll,
      toggleSelectAll,
        addCustomField,
        emitFormData
      };
    },
  };
</script>

